import ConnectMarketplace from '../ConnectMarketplaceNew';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import ConnectMarketplaceWizard, { ConnectMarketplaceWizardProps } from '../ConnectMarketplaceWizard';
import ConnectMarketplaceHeader from '../ConnectMarketplaceHeader';
import { MarketplaceRegion } from 'src/graphql/generated';
import { ConnectMarketplaceWizardBloc } from '../ConnectMarketplaceWizardBloc';
import { ConnectEbayBloc } from './ConnectEbayBloc';
import ConnectEbayForm from './ConnectEbayForm';

interface ConnectAmazonOrchestratorProps {
    region: MarketplaceRegion;
    showWizardComponents: boolean;
}

export const ConnectEbayOrchestrator: FunctionComponent<ConnectAmazonOrchestratorProps> = ({
    region,
    showWizardComponents,
}) => {
    const { t } = useTranslation();

    const parentBloc = new ConnectMarketplaceWizardBloc(1, region, t);
    const stepBlocs = [new ConnectEbayBloc(region, parentBloc, null, t)];
    return (
        <ConnectEbay
            region={region}
            bloc={parentBloc}
            stepBlocs={stepBlocs}
            i18nPrefix={'connectEbay'}
            showWizardComponents={showWizardComponents}
        />
    );
};

export const ConnectEbay: FunctionComponent<ConnectMarketplaceWizardProps> = (props) => {
    return (
        <ConnectMarketplaceWizard {...props}>
            <ConnectMarketplace form={ConnectEbayForm as any} header={ConnectMarketplaceHeader} />
        </ConnectMarketplaceWizard>
    );
};
